export function specialties (state) {
  return state.specialties
}

export function profissionaisAgenda (state) {
  return state.profissionaisAgenda
}

export function local (state) {
  return state.local
}

export function user (state) {
  return state.user
}

export function userCpfDigital (state) {
  return state.userCpfDigital
}

export function podeIncluirHorarioExtra (state) {
  return state.podeIncluirHorarioExtra
}

export function endereco (state) {
  return state.endereco
}

export function professionals (state) {
  return state.professionals
}

export function schedules (state) {
  return state.schedules
}

export function schedulesToAddTime(state) {
  return state.schedulesToAddTime
}

export function medicalInsurances (state) {
  return state.medicalInsurances
}

export function individuals (state) {
  return state.individuals
}

export function individual (state){
  return state.individual
}

export function agendamentosSgh (state) {
  return state.agendamentosSgh
}

export function status (state) {
  return state.status
}

export function datasAgenda (state) {
  return state.datasAgenda
}

export function logo (state) {
  return state.logo
}

export function cpfObrigatorio (state) {
  state.cpfObrigatorio
}

export function telehealth (state) {
  return state.telehealth
}

export function cities (state) {
  return state.cities
}

export function tipoAgendamentoSgh(state) {
    return state.tipoAgendamentoSgh;
}

export function appointmentTypes(state) {
    return state.appointmentTypes;
}